module.exports = __webpack_public_path__ + "img/twitter-icon.c5d6dfb7.png";